"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('hair-dryer', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M44 8.5V17.5C44 17.5 41.0994 18.0675 37 18.7995C31.8328 19.7221 24.761 20.9059 19.193 21.5438C16.7395 21.8249 14.578 22 13 22C12.7461 22 12.4947 21.9895 12.2461 21.9689C7.62831 21.5859 4 17.7167 4 13C4 8.02944 8.02944 4 13 4C18.159 4 29.5559 5.87138 37 7.20054C41.0994 7.93249 44 8.5 44 8.5Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M14.6197 40.9578C14.837 42.6958 16.3144 44 18.0659 44C20.1549 44 21.7711 42.1691 21.512 40.0963L19.193 21.5438C16.7395 21.8249 14.578 22 13 22C12.7461 22 12.4947 21.9895 12.2461 21.9689L14.6197 40.9578Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M19.193 21.5438L21.512 40.0963C21.7711 42.1691 20.1549 44 18.0659 44C16.3144 44 14.837 42.6958 14.6197 40.9578L12.2461 21.9689M19.193 21.5438C16.7395 21.8249 14.578 22 13 22C12.7461 22 12.4947 21.9895 12.2461 21.9689M19.193 21.5438C24.761 20.9059 31.8328 19.7221 37 18.7995M12.2461 21.9689C7.62831 21.5859 4 17.7167 4 13C4 8.02944 8.02944 4 13 4C18.159 4 29.5559 5.87138 37 7.20054M37 7.20054C41.0994 7.93249 44 8.5 44 8.5V17.5C44 17.5 41.0994 18.0675 37 18.7995M37 7.20054V18.7995",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("circle", {
    cx: "13",
    cy: "13",
    r: "3",
    fill: props.outFillColor,
    stroke: props.innerStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }));
});

exports.default = _default;